"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OLElement;
var _react = _interopRequireDefault(require("react"));
var _ListElement = _interopRequireDefault(require("./ListElement"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function OLElement(props) {
  return /*#__PURE__*/_react.default.createElement(_ListElement.default, _objectSpread(_objectSpread({}, props), {}, {
    listType: 'ol'
  }));
}